import { useState, type FormEvent } from 'react';
import { api } from '../lib/api.ts';

export default function Login({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [epost, setEpost] = useState('');
  const [passord, setPassord] = useState('');
  const [feil, setFeil] = useState<string | null>(null);
  const [jobber, setJobber] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setFeil(null);
    setJobber(true);
    try {
      await api.post('/auth/login', { epost, passord });
      onLoggedIn();
    } catch (err) {
      setFeil(err instanceof Error ? err.message : 'Innlogging feilet');
    } finally {
      setJobber(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-xl bg-white p-8 shadow-lg ring-1 ring-slate-200"
      >
        <div className="mb-6 text-center">
          <div className="text-3xl">⚡</div>
          <h1 className="mt-2 text-2xl font-bold text-slate-800">Billading</h1>
          <p className="mt-1 text-sm text-slate-500">Logg inn for å fortsette</p>
        </div>

        <label className="block text-sm font-medium text-slate-700">
          E-post
          <input
            type="email"
            required
            autoFocus
            value={epost}
            onChange={(e) => setEpost(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </label>

        <label className="mt-4 block text-sm font-medium text-slate-700">
          Passord
          <input
            type="password"
            required
            value={passord}
            onChange={(e) => setPassord(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </label>

        {feil && <p className="mt-3 text-sm text-red-600">{feil}</p>}

        <button
          type="submit"
          disabled={jobber}
          className="mt-6 w-full rounded-lg bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {jobber ? 'Logger inn …' : 'Logg inn'}
        </button>
      </form>
    </div>
  );
}
